MOVE.MORTGAGE.RATE_TRENDS_GRAPH_HELPER = (function (MORTGAGE) {

  var getOverallPercent = function (data) {
    var lastDay = _.last(data.trends_data);
    return lastDay.toFixed(2) + "%";
  };

  var getRateChange = function (data) {
    var days = _.last(data.trends_data, 2);
    var prevDay = days[0],
      lastDay = days[1];
    return (lastDay - prevDay).toFixed(2);
  };

  var getRateChangeArrow = function (data) {
    var change = getRateChange(data);
    if (change < 0) {
      return 'down';
    }
    if (change > 0) {
      return 'up';
    }
    return 'neutral';
  };

  var mapRateTrendsData = function (datasets, rate_trends) {
    _.each(rate_trends, function (trend) {
      datasets.y30.trends_data.push(trend.R30);
      datasets.y15.trends_data.push(trend.R15);
      datasets.a51.trends_data.push(trend.A51);
    });
    return datasets;
  };

  var getBrokenPoints = function (data) {
    var points = {},
      point_min = [],
      point_max = [];
    $.each(data.series, function (index, value) {
      point_min.push(value.min);
      point_max.push(value.max);
    });
    points.min = Math.min.apply(Math, point_min);
    points.max = Math.max.apply(Math, point_min);
    points.mid = point_max.sort(function (a, b) {
      return a - b;
    })[1];
    return points;
  };

  var draw = function (data, updateTitleCallback) {
    $(data.css_class).highcharts({
      chart: {
        backgroundColor: 'transparent',
        type: 'spline',
        renderTo: 'container'
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      xAxis: {
        visible: false
      },
      yAxis: {
        visible: false
      },
      tooltip: {
        enabled: false,
        lineWidth: 0,
        lineColor: null,
        radius: 0
      },
      plotOptions: {
        spline: {
          color: data.line_color,
          lineWidth: 2
        }
      },
      series: [{
        cursor: data.cursor || 'pointer',
        showInLegend: false,
        data: data.trends_data,
        marker: {
          radius: 0,
          enabled: false
        },
        states: {
          hover: {
            enabled: true
          }
        },
        point: {
          events: {
            click: function () {
              window.open(data.trend_url, '_self');
            }
          }
        }
      }]
    }, function () {
      data.overallPercent = getOverallPercent(data);
      data.rateChangeArrow = getRateChangeArrow(data);
      data.rateChange = getRateChange(data);
      updateTitleCallback(data);
    });
  };

  var drawOnMobile = function (data, updateTitleCallback) {
    getBrokenPoints(data);
    $('.mobile-chart').highcharts({
      chart: {
        backgroundColor: 'transparent',
        type: 'spline',
        renderTo: 'container',
        height: 210
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      xAxis: {
        visible: false
      },
      yAxis: {
        tickInterval: 0.125,
        title: {
          text: null
        },
        opposite: true,
        labels: {
          formatter: function () {
            return this.value.toFixed(3) + '%';
          }
        }
      },
      tooltip: {


        enabled: true,
        lineWidth: 0,
        lineColor: null,
        radius: 0,
        formatter: function() {
          return '<b>'+ this.y.toFixed(3) +'%</b>'
          }
      },
      plotOptions: {
        spline: {
          color: data.line_color,
          lineWidth: 2
        }
      },
      series: data.series
    }, function () {
      $.each(data.title, function (index, element) {
        var header = {};
        header.overallPercent = getOverallPercent(element);
        header.rateChangeArrow = getRateChangeArrow(element);
        header.css_class = element.css_class;
        header.title = element.title;
        updateTitleCallback(header);
      });
    });
  };

  MORTGAGE.RATE_TRENDS_GRAPH_HELPER = {
    draw: draw,
    drawOnMobile: drawOnMobile,
    mapRateTrendsData: mapRateTrendsData,
    getOverallPercent: getOverallPercent,
    getRateChange: getRateChange,
    getRateChangeArrow: getRateChangeArrow
  };

  return MORTGAGE.RATE_TRENDS_GRAPH_HELPER;
})(MOVE.MORTGAGE || {});



// WEBPACK FOOTER //
// ./mortgage/rate_trends_graph_helper.js